import styled from 'styled-components';

export const Loader = styled.div`
    text-align: center;
`;
